import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=142c84c4&"
import script from "./counter.vue?vue&type=script&setup=true&lang=js&"
export * from "./counter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./counter.vue?vue&type=style&index=0&id=142c84c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports